<template>
  <div class="content">
    <div class="container-fluid">
      <reload frase="Estamos Processando seu envio, Aguarde um momento!"  v-if="reload_hab"></reload>

      <div class="col-md-12" v-if="msgAlterada" style="padding-left: 0px;padding-right: 0px;">
          <div
              class="card"
              style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;"
              v-if="msg==1"
          >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">{{msgAlterada}}</div>
                </div>
              </div>
          </div>
          <div
              class="card"
              style="background-color: rgb(170 72 50) !important;color: #fff !important;margin-bottom: 20px !important;"
              v-if="msg==0"
          >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">{{msgAlterada}}</div>
                </div>
              </div>
          </div>
          <div
              class="card"
              style="background-color: rgb(191 187 54) !important;color: #fff !important;margin-bottom: 20px !important;"
              v-if="msg==2"
          >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">{{msgAlterada}}</div>
                </div>
              </div>
          </div>
      </div>      

      <div class="">
          <card class="col-md-12 padding-zero-top" >
            <h4 slot="header" class="card-title m-cidadao">Manifestar-se</h4>
            <form>
              <div class="row">
                <div class="col-md-6 padding-zero-top">
                  <div class="form-group">
                    <label for="sel1">Tipo:</label>
                    <select class="form-control" id="tipo" name="tipo" v-model="manifesto.tipo">
                      <option v-for="a in tiposAssunto" :key="a.id" :value="a.nome">
                        {{ a.nome }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-12 padding-zero-top">
                    <label>Assunto:</label><br>
                    <label for="sel1" class="manif-tipo-color">Sobre qual assunto você quer falar?</label>
                    <input
                      type="text"
                      placeholder="Assunto"
                      maxlength="250"
                      v-model="manifesto.assunto"
                      v-on:blur="validacaoAssunto(manifesto.assunto)"
                      class="form-control"
                      :style="styleAssunto"
                    />
                    <div v-if="assuntoverify==0">
                        <label
                          class="control-label"
                          v-if="styleAssunto!=''"
                          style="color:rgb(243 0 0);font-size: 12px;"
                        >*Obrigatorio</label>
                    </div>
                    <label
                      class="control-label"
                      v-if="assuntoverify==1"
                      style="color:rgb(183 179 55);font-size: 12px;"
                    >* Minimo 6 caracteres</label>
                </div>
              </div>
              <div class="row" style="margin-top: 20px;">  
                <div class="col-md-12 padding-zero-top">
                  <div class="form-group">
                    <label for="descricao">Descrição:</label><br>
                    <label class="manif-tipo-color"> Descreva abaixo o que deseja.
                       Seja claro e objetivo. Não utilize o campos abaixo para
                        informações pessoais, só informe dados que são essenciais
                         para a caracterização da manifestação.
                    </label>
                      <textarea
                        class="form-control"
                        rows="5"
                        id="descricao"
                        name="descricao"
                        v-model="manifesto.descricao"
                        v-on:blur="validacaoDescricao(manifesto.descricao)"
                        :style="styleDescricao"
                        maxlength="2000"
                      ></textarea>
                      <label class="control-label" v-if="manifesto.descricao != null">{{
                        manifesto.descricao.length
                      }}</label
                      >
                      <div v-if="descricaoverify==0">
                        <label
                          class="control-label"
                          v-if="styleDescricao!=''"
                          style="color:rgb(243 0 0);font-size: 12px;"
                        >*Obrigatorio</label>
                      </div>
                      <label
                        class="control-label"
                        v-if="descricaoverify==1"
                        style="color:rgb(183 179 55);font-size: 12px;"
                      >* Minimo 30 caracteres</label>
                    
                  </div>
                </div>
              </div>
              <div v-if="manifesto.tipo!='Elogio'">
                <div class="row">  
                  <div class="col-md-12 padding-zero-top">
                    <h4 class="m-cidadao" >Local da Ocorrência</h4>
                  </div>  
                </div>    
                <div class="row" style="margin-top: 20px;">
                  <div class="col-md-10 padding-zero-top">
                    <base-input type="text"
                              id="rua"
                              name="rua"
                              label="Rua"
                              placeholder="Rua"
                              v-model="manifesto.rua"
                              maxlength="150">
                    </base-input>  
                  </div>
                  <div class="col-md-2 padding-zero-top">
                    <base-input type="number"
                              id="numero"
                              name="numero"
                              label="Número"
                              placeholder="Número"
                              v-model="manifesto.numero"
                              maxlength="150">
                    </base-input>  
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-7 padding-zero-top">
                    <base-input type="text"
                              id="complemento"
                              name="complemento"
                              label="Complemento"
                              placeholder="Complemento"
                              v-model="manifesto.complemento"
                              maxlength="150">
                    </base-input>  
                  </div>
                  <div class="col-md-5 padding-zero-top">
                    <base-input type="text"
                              id="bairro"
                              name="bairro"
                              label="Bairro"
                              placeholder="Bairro"
                              v-model="manifesto.bairro"
                              maxlength="150">
                    </base-input>  
                  </div>
                </div>
              </div>


              <div class="text-center">
                <button type="submit" class="btn btn-primary btn-fill float-left" @click.prevent="manifestoCadastrar" v-if="desativar==0">  
                  Cadastrar Manifestação
                </button>
                <button type="submit" class="btn btn-primary btn-fill float-left" disabled v-if="desativar==1">  
                  Cadastrar Manifestação
                </button>
              </div>
              <div class="clearfix" style="margin-bottom:20px"></div>
            </form>
          </card>
      </div>
    </div>
  </div>
</template>
<script>

  import Reload from 'src/components/Reload-v1.vue'
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import StatsCard2 from 'src/components/Cards/StatsCard2.vue'
  import StatsCard3 from 'src/components/Cards/StatsCard3.vue'
  import StatsCard4 from 'src/components/Cards/StatsCard4.vue'
  import LTable from 'src/components/Table.vue'

  import axios from 'axios';
  import store from "src/store.js"
  import store_cidadao from "src/storeCidadao.js"
  import 'src/controller/cidadao/cidadaoController.js'
  import 'src/controller/site/homeController.js'
  import 'src/controller/loginController.js'
  import "src/controller/tiposController.js";
  import "src/controller/sistema/manifestacaoController.js";

  export default {
    components: {
      Reload,
      LTable,
      ChartCard,
      StatsCard,
      StatsCard2,
      StatsCard3,
      StatsCard4
    },
    data () {
      return {
        reload_hab: false,
        desativar:0,
        espera:0,
        manifesto:{
          tipo:"Reclamação",
          secretaria:1,
          assunto:null,
          descricao:null,
          rua:null,
          numero:null,
          bairro:null,
          complemento:null,
          ouvidor_id: null,
        },
        msgAlterada: null,
        msg: null,
        assuntoverify:0,
        descricaoverify:0,
        styleAssunto:"",
        styleDescricao:"",
        verify_assunto:false,
        verify_descricao:false,
        me:0,
        assuntos:[],
        secretarias:[],
        tiposAssunto:[],
        result:[],
        manifestacao:null,
        manifestacao_exibir:[],
        manifestacao_espera:[],
      }
    },
    methods: {
        validacaoAssunto(assunto){
        if (assunto) {
          this.msgAlterada = "";
          this.styleAssunto ="";
          this.styleDescricao="";


          this.assuntoverify =0;
          this.verify_assunto = true;
        } else {
          this.styleAssunto = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Assunto está Vazio!";
          this.msg = 0;
          this.assuntoverify =0;
          this.verify_assunto = false;
          return false;
        }
      },
      validacaoDescricao(descricao){
        if (descricao) {
          this.msgAlterada = "";
          this.styleAssunto ="";
          this.styleDescricao="";

          this.descricaoverify =0;
          this.verify_descricao = true;
        } else {
          this.styleDescricao = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Descrição está Vazio!";
          this.msg = 0;
          this.descricaoverify =0;
          this.verify_descricao = false;
          return false;
        }
      },
      async manifestoCadastrar(){
        try {
          scroll(0, 50);
          this.manifesto.ouvidor_id = store.id;

          this.msgAlterada ="";
          this.styleAssunto ="";
          this.styleDescricao="";

          if (this.manifesto.assunto == null || this.manifesto.assunto =="") {
            this.styleAssunto = "border: 2px solid rgb(243 0 0);";
            this.msgAlterada = "O campo Assunto está Vazio!";
            this.msg = 0;
            this.desativar = 0;
            return false;
          }

          if (this.manifesto.descricao == null || this.manifesto.descricao =="") {
            this.styleDescricao = "border: 2px solid rgb(243 0 0);";
            this.msgAlterada = "O campo Descricao está Vazio!";
            this.msg = 0;
            this.desativar = 0;
            return false;
          }
          if(this.verify_descricao && this.verify_assunto){
            this.desativar = 1;
            //ativar reload
            this.reload_hab = true;
            //cadastrar manifesto
            let data = await this.$manifestarAnonimoComOuvidor(this.manifesto);
            let result = data.data;
            
            if (data.msg == "Campos Vazios!") {
              this.msgAlterada = data.msg;
              this.msg = 0;
              this.desativar = 0;
              this.reload_hab = false;
              return false;
            }
          
            if (data.msg == "Manifestação cadastrada com sucesso!") {
              this.msgAlterada = data.msg;
              this.msg = 1;
              this.desativar = 0;
              this.reload_hab = false;
              this.manifesto.tipo = "Reclamação";
              this.manifesto.secretaria = 1;
              this.manifesto.assunto = null;
              this.manifesto.descricao = null;
              this.manifesto.rua = null;
              this.manifesto.numero = null;
              this.manifesto.bairro = null;
              this.manifesto.complemento = null;
              this.manifestacao_espera = [];
            }
          }
        }catch (e) {
          console.log(e);
          this.reload_hab = false;
        }
      },
      async listarTAssunto(){
        try {
          let data = await this.$listarTiposAssunto();
          this.tiposAssunto = data.data;
        } catch (e) {
          
        }
      },
    },
    beforeMount(){
       try {
        this.listarTAssunto();

       } catch (e) {
         
       }
    }

  }
</script>
